/* npm version only adapted from https://github.com/slifszyc/user-agent */

import ie from './user-agent/ie';
import ff from './user-agent/ff';
import chrome from './user-agent/chrome';
import safari from './user-agent/safari';
import mac from './user-agent/mac';

/**
 * Expose browser constructors
 */

export { ie, ff, chrome, safari, mac };



// WEBPACK FOOTER //
// ./src/modules/npm-component/user-agent.js